import { getParLevelForProduct } from './parLevelPaywall'

export const PAR_READINESS_SET_PARS_CTA = 'Set pars'

export const PAR_READINESS_OTP_STOCK_CTA = 'Open Stock'

export const PAR_READINESS_OTP_HEADLINE =
  "We'll tell you what to reorder after a count"

export const PAR_READINESS_OTP_BODY =
  "Set how much to keep on this list. Then open Stock, count what's on the shelf, save, and add the gap to the basket. One supplier is enough — you don't need a full house count."

export const PAR_READINESS_OTP_HINT =
  'Count on Stock, save, then add the gap to the basket.'

export const PAR_SET_PARS_ROW_HINT = 'Par on this row — 0 means none set'

export const summarizeParReadiness = (venueProducts = []) => {
  const list = Array.isArray(venueProducts) ? venueProducts : []
  const total = list.length
  const withPar = list.filter(
    product => getParLevelForProduct(product) > 0,
  ).length
  return {
    withPar,
    total,
    ready: total > 0 && withPar === total,
  }
}

export const formatParReadinessBanner = (venueProducts = []) => {
  const { withPar, total } = summarizeParReadiness(venueProducts)
  if (total <= 0) return null
  return `${withPar} / ${total} products have a keep level · ${PAR_READINESS_OTP_HINT}`
}

/** First shopping-list product without a keep level, else the first row. */
export const pickProductToSetPar = (venueProducts = []) => {
  const list = (Array.isArray(venueProducts) ? venueProducts : []).filter(
    product => product && product._id,
  )
  return (
    list.find(product => getParLevelForProduct(product) <= 0) || list[0] || null
  )
}
